import { NgModule } from '@angular/core';
import { MatButton, MatButtonModule, MatDatepickerModule, MatMenuModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcButtonComponent } from './fc-button.component';


@NgModule({
  entryComponents: [
    FcButtonComponent
  ],
  declarations: [
    FcButtonComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatIconModule,

    PipesModule,
    MatMenuModule
  ],
  exports: [
    FcButtonComponent
  ]
})
export class FcButtonModule {}
